module.exports = __webpack_public_path__ + "static/media/Palestro - LT Grey_DK Chocolate.874342d7.jpg";